import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GeneralLedgerService } from '../../services/general-ledger.service';
import { PrintService } from '../../services/print.service';

export interface ThirdPartySalesGlRow {
	company_name: string;
	region: string;
	source_no: string;
	customer_name: string;
	gl_account: string;
	document_type: string;
	posting_date: string;
	month_name: string;
	document_no: string;
	sales_order_number: string;
	name_category: string;
	amount_usd: number;
	amount_lcy: number;
}

@Component({
	selector: 'app-third-party-sales-gl-report',
	templateUrl: './third-party-sales-gl-report.component.html',
	styleUrls: ['./third-party-sales-gl-report.component.scss']
})
export class ThirdPartySalesGlReportComponent implements OnInit {
	@ViewChild('print_table') printTableRef: ElementRef;
	formGroup: UntypedFormGroup;
	loading = false;
	exporting = false;
	report: { rows: ThirdPartySalesGlRow[]; totals: { amount_usd: number; amount_lcy: number }; fromdate: string; todate: string } | null = null;
	color: string;

	constructor(
		private location: Location,
		private generalLedgerService: GeneralLedgerService,
		private globalSearchService: GlobalSearchService,
		private printService: PrintService,
		private fb: UntypedFormBuilder
	) {}

	ngOnInit(): void {
		this.color = this.globalSearchService.getColor();
		const today = new Date();
		const firstOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
		this.formGroup = this.fb.group({
			fromdate: [firstOfMonth.toISOString().slice(0, 10), [Validators.required]],
			todate: [today.toISOString().slice(0, 10), [Validators.required]],
		});
	}

	back(): void {
		this.location.back();
	}

	runReport(): void {
		if (!this.formGroup || !this.formGroup.valid) { return; }
		this.loading = true;
		const val = this.formGroup.value;
		const payload = { fromdate: val.fromdate, todate: val.todate };
		this.generalLedgerService.getThirdPartySalesGlReport(payload).subscribe({
			next: (results: any) => {
				this.loading = false;
				if (results.error) {
					this.globalSearchService.showNotification(results.error, 'danger', 'bottom', 'center');
					return;
				}
				this.report = results;
			},
			error: () => { this.loading = false; }
		});
	}

	exportExcel(): void {
		if (!this.report || !this.report.rows || !this.report.rows.length) { return; }
		const rows = this.report.rows.map((r: ThirdPartySalesGlRow) => ({
			'Company Name': r.company_name,
			Region: r.region,
			No: r.source_no,
			Name: r.customer_name,
			'GL Account': r.gl_account,
			'Document Type': r.document_type,
			'Posting Date': r.posting_date,
			Month: r.month_name,
			Document: r.document_no,
			'Sales Order Number': r.sales_order_number,
			'Name (Category)': r.name_category,
			'Amount in USD': r.amount_usd,
			'Amount in LCY': r.amount_lcy,
		}));
		rows.push({
			'Company Name': '', Region: '', No: '', Name: '', 'GL Account': '', 'Document Type': '', 'Posting Date': '', Month: '', Document: '', 'Sales Order Number': '', 'Name (Category)': 'Total',
			'Amount in USD': this.report.totals.amount_usd, 'Amount in LCY': this.report.totals.amount_lcy,
		});
		this.globalSearchService.exportJsonToExcel(rows, 'ThirdPartySalesGL_' + new Date().toISOString().slice(0, 10) + '.xlsx');
	}

	exportPdf(): void {
		if (!this.report || !this.report.rows || !this.report.rows.length || !this.printTableRef) { return; }
		this.exporting = true;
		const encoded = this.globalSearchService.base64encode(this.printTableRef.nativeElement.innerHTML);
		const filename = 'ThirdPartySalesGL_' + new Date().toISOString().slice(0, 10) + '.pdf';
		this.printService.pdf({ content: encoded, filename }).subscribe({
			next: (result: any) => {
				this.globalSearchService.downloadPdf(result.content, filename);
				this.exporting = false;
			},
			error: () => { this.exporting = false; }
		});
	}
}
